<template>
  <b-container class="text-base pt-2 pr-3 pb-2 pl-4 ">
    <b-row class="text-16 mb-1">{{ title }}</b-row>
    <b-container class="pl-0">
      <b-row style="line-height: 1.2;" class="text-14 align-items-center">
        <span class="text-18">{{ qtd }}</span>
        &nbsp;pedidos
      </b-row>
      <b-row class="text-18 gc">{{ value }}</b-row>
      <b-row class="text-12">Ticket Médio</b-row>
      <b-row class="text-14 bc">{{ ticket }}</b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  props: [
    'title',
    'qtd',
    'value',
    'ticket'
  ]
}
</script>

<style>
  .bc {
    color: #0BA7DA;
  }

  .gc {
    color: #7ABA1E;
  }
</style>
